(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.common.formly.inputs.radio-required'

  require('angular')
    .module(MODULE_NAME, [
      require('angular-formly'),
      require('angular-formly-templates-bootstrap')
    ])
    .run(radioWrapperConfig)

  radioWrapperConfig.$inject = ['formlyConfig']
  function radioWrapperConfig (formlyConfig) {
    formlyConfig.setType({
      name: 'radio-required',
      extends: 'radio',
      wrapper: ['bootstrapLabel', 'bootstrapHasError', 'validation']
    })
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/formly/inputs/radio-required.js